import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

export function ContentReadArea(props) {
  const className = `${style.read} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

ContentReadArea.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * child components to render on ContentReadArea
   */
  children: PropTypes.arrayOf(PropTypes.element),
};

ContentReadArea.defaultProps = {
  className: '',
};
